import { useContext, useEffect } from 'react';
import { PresenceContext } from './presenceContextValue';

export function usePresence() {
  return useContext(PresenceContext);
}

// Small hook sugar for pages that want to report which deal the user
// is looking at without wrestling with the setter directly. Clears on
// unmount and on id change so the old id never lingers.
export function useReportViewingDeal(dealId) {
  const { setViewingDealId } = usePresence();
  useEffect(() => {
    if (!dealId) return undefined;
    setViewingDealId(dealId);
    return () => setViewingDealId(null);
  }, [dealId, setViewingDealId]);
}
